// extracted by mini-css-extract-plugin
module.exports = {"App_title":"Home_App_title__2I286"};